import React, { useEffect } from 'react';
import './TermsPrivacy.css';

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="terms-privacy" id="privacy">
      <div className="container-custom">
        <div className="terms-privacy-content">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last updated: December 28, 2025</p>

          <h2>Information We Collect</h2>
          <p>We collect information you provide via forms (name, email, phone, message, CVs) and metadata such as IP address and browser user agent. We may also use cookies and third-party analytics.</p>

          <h2>How We Use Information</h2>
          <p>We use your information to respond to inquiries, provide services, process job applications, and send occasional service-related communications. We do not sell personal data.</p>

          <h2>Sharing & Third Parties</h2>
          <p>We may share data with service providers who help operate the website (email providers, hosting, analytics). We require such providers to protect personal data and use it only for the contracted purpose.</p>

          <h2>Data Security & Retention</h2>
          <p>We take reasonable measures to protect data. We retain personal data only as long as necessary for the purposes described or as required by law.</p>

          <h2>Your Rights</h2>
          <p>You may request access, correction, or deletion of personal data we hold about you. To make a request, use the contact details on the website.</p>

          <h2>Cookies</h2>
          <p>We use cookies for site functionality and analytics. You can manage cookie settings via your browser.</p>

          <h2>Children</h2>
          <p>This website is not directed to children under 16 and we do not knowingly collect their data.</p>

          <h2>Changes</h2>
          <p>We may update this policy; changes will be posted here with an updated date.</p>

          <h2>Contact</h2>
          <p>For privacy inquiries, contact us using the site contact page.</p>
        </div>
      </div>
    </section>
  );
};

export default Privacy;
